<template>
    <div>
        สำหรับการเรียกใช้คำสั่งที่มี การสร้าง หรือแก้ไขข้อมูล ผลลัพท์ที่จะตอบกลับมาจะมีรูปแบบเหมือนกันดังนี้

        <ul>
            <li>
                <b>สำเร็จ</b>
<div v-highlight><pre class="language-json"><code>{"status":"success"}</code></pre></div>
            </li>
            <li>
                <b>ไม่สำเร็จ</b>
<div v-highlight><pre class="language-json"><code>{"status":"error","error_code":###,"error_message":"..."}</code></pre></div>
            </li>
            <li>
                <b>สำเร็จบางส่วน มีข้อผิดพลาดบ้างส่วน (ในกรณีที่ส่งคำสั่งแบบ Batch)</b>
<div v-highlight><pre class="language-json"><code>{"status":"partial","error_code":###,"error_message":"..."}</code></pre></div>
            </li>
        </ul>

        สำหรับการเรียกใช้คำสั่ง เพื่อดึงข้อมูล สามารถดูผลลัพท์ได้จากตารางในแต่ละคำสั่ง

    </div>
</template>

<script>
    export default {
        name: "Response"
    }
</script>

<style scoped>

</style>